import styled, { css } from 'styled-components';
export const Button = styled.button `
  display: inline-flex;
  align-items: center;

  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;

  cursor: pointer;

  appearance: none !important; // NOTE: Required for Safari.

  ${({ $appearance }) => $appearance === 'inherit' &&
    css `
      color: inherit;
    `}

  ${({ $appearance }) => $appearance === 'primary' &&
    css `
      color: var(--text-primary);
    `}

  ${({ $appearance }) => $appearance === 'secondary' &&
    css `
      color: var(--text-secondary);
    `}

  ${({ $appearance }) => $appearance === 'destructive' &&
    css `
      color: var(--text-critical);
    `}

  ${({ $appearance }) => $appearance === 'success' &&
    css `
      color: var(--text-success);
    `}

  ${({ $appearance }) => $appearance === 'warning' &&
    css `
      color: var(--text-alert);
    `}

    ${({ theme }) => {
    var _a, _b;
    return ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.paleTextColor) &&
        css `
      color: ${theme.automated.styles.paleTextColor};
    `;
}}

  &:hover,
  &:active,
  &:focus {
    ${({ $appearance }) => $appearance === 'primary' &&
    css `
        color: var(--text-brand);
      `}

    ${({ $appearance }) => $appearance === 'secondary' &&
    css `
        color: var(--text-primary);
      `}

    ${({ $appearance }) => $appearance === 'destructive' &&
    css `
        color: var(--text-critical);
      `}

    ${({ $appearance }) => $appearance === 'success' &&
    css `
        color: var(--text-success);
      `}

    ${({ $appearance }) => $appearance === 'warning' &&
    css `
        color: var(--text-alert);
      `}

    ${({ theme }) => {
    var _a, _b;
    return ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.colorOnBackground) &&
        css `
        color: ${theme.automated.styles.colorOnBackground};
      `;
}}

    ${({ disabled }) => disabled &&
    css `
        color: inherit;
      `}
  }

  ${({ $withUnderline }) => $withUnderline &&
    css `
      text-decoration-line: underline;
    `}

  ${({ disabled }) => disabled &&
    css `
      cursor: not-allowed;
    `}

  & > svg {
    margin-right: var(--space-200);
  }
`;
//# sourceMappingURL=ButtonClean.styled.js.map